export type DateKey = `${number}-${string}-${string}`; // YYYY-MM-DD (not runtime-validated)

export function isDateKey(v: string): v is DateKey {
  return /^\d{4}-\d{2}-\d{2}$/.test(v);
}

/** Format a Date as YYYY-MM-DD in *local* time (never UTC-shift via toISOString). */
export function toLocalDateKey(date: Date): DateKey {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/** Parse YYYY-MM-DD into a Date at *UTC* midnight (date-only semantics). */
export function parseUtcDateKey(key: string): Date {
  const head = key.split('T')[0];
  const [y, m, d] = head.split('-').map((x) => Number(x));
  if (!y || !m || !d) throw new Error(`Invalid date key: ${key}`);
  return new Date(Date.UTC(y, m - 1, d, 0, 0, 0, 0));
}

/** Format a Date as YYYY-MM-DD using *UTC* fields (date-only semantics). */
export function toUtcDateKey(date: Date): DateKey {
  const y = date.getUTCFullYear();
  const m = String(date.getUTCMonth() + 1).padStart(2, '0');
  const d = String(date.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/** Add days to a UTC-midnight Date and return a new Date. */
export function addDaysUtc(utcMidnight: Date, days: number): Date {
  const d = new Date(utcMidnight);
  d.setUTCDate(d.getUTCDate() + days);
  return d;
}

/** Whole-day difference between two YYYY-MM-DD keys (b - a), timezone-agnostic. */
export function diffDaysBetweenDateKeys(a: string, b: string): number {
  const da = parseUtcDateKey(a);
  const db = parseUtcDateKey(b);
  return Math.round((db.getTime() - da.getTime()) / 86400000);
}

